/**
 * Games Info View
 */

define(function(require, exports, module) {
    var $ = require('j');
    var _ = require('underscore');
    var Class = require('Class');
    var listOfUnloadedImages = [];

    module.exports = Class.create({

        _isStarted: false,
        _imageLoadPromise: null,
        _rotationTimerPromise: null,

        _$currentGameWithDynamicImage: null,
        _currentGameStaticBackgroundImage: null,
        _$nextGameWithDynamicImage: null,

        _$currentPageGames: [],

        _IMAGE_LOAD_TIMEOUT: 20000,

        initialize: function(gamesInfoView) {
            this._gamesInfoView = gamesInfoView;
        },

        enable: function() {
            if (this._isStarted || !this._gamesInfoView.model.get('enableAnimatedGif')) {
                return;
            }
            var games = this._gamesInfoView.model.games;
            this._$currentPageGames = $(this._gamesInfoView.$('.fn-game-items')
                .eq(this._gamesInfoView._getActivePage())
                .find('.fn-game-item-wrapper')
                .filter(function(gameWrapperEl) {
                    var gameCode = this._getGameCode(gameWrapperEl);
                    var dynamicImageUrls = games.get(gameCode).get('animatedImageURLs');
                    var isTopLevelWrapper = !$(gameWrapperEl).parents('.fn-game-item-wrapper', true).length;

                    dynamicImageUrls = _.values(dynamicImageUrls).toString();

                    return !_.isEmpty(dynamicImageUrls) && isTopLevelWrapper;
                }.bind(this))
            );

            if (!this._$currentPageGames.length) {
                return;
            }

            this._isStarted = true;

            this._proceedRotation(this._moveToNextGame());
        },

        disable: function() {
            if (!this._isStarted || !this._gamesInfoView.model.get('enableAnimatedGif')) {
                return;
            }

            this._isStarted = false;
            this._imageLoadPromise && this._imageLoadPromise.reject();
            this._rotationTimerPromise && this._rotationTimerPromise.reject();
        },

        //region Flow methods

        _proceedRotation: function(imageLoadPromise, timerPromise) {
            this._imageLoadPromise = imageLoadPromise;
            this._rotationTimerPromise = timerPromise;

            $.when(imageLoadPromise, timerPromise)
                .done(function() {
                    this._restoreStaticGameImage();
                    this._setDynamicGameImage();

                    // Note: we start timer only after dynamic image show
                    this._proceedRotation(this._moveToNextGame(), this._startTimer());
                }.bind(this))
                .fail(function() {
                    if (!this._isStarted) {
                        this._restoreStaticGameImage();
                        return;
                    }

                    this._proceedRotation(this._moveToNextGame(), timerPromise);
                }.bind(this));
        },

        _moveToNextGame: function(promise) {
            promise = promise || $.Deferred();

            this._getNextGame();

            this._loadImage()
                .done(function() {
                    promise.resolve();
                })
                .fail(function() {
                    window.setTimeout(function() {
                        if (!this._isStarted) {
                            return;
                        }
                        this._moveToNextGame(promise);
                    }.bind(this), 500);
                }.bind(this));

            return promise;
        },

        _getNextGame: function() {
            var $games = this._getVisibleGames();

            if (!$games.length) {
                this._$nextGameWithDynamicImage = null;
                return;
            }

            var gameItemsIndexes = _.range($games.length);
            var dynamicGameItemIndex = this._$currentGameWithDynamicImage
                ? $games.indexOf(this._$currentGameWithDynamicImage[0])
                : -1;
            var staticGameItemsIndexes = _.difference(gameItemsIndexes, [dynamicGameItemIndex]);
            var randomItemIndex = Math.floor(Math.random() * staticGameItemsIndexes.length);

            this._$nextGameWithDynamicImage = $games.eq(
                this._$currentGameWithDynamicImage
                    ? staticGameItemsIndexes[randomItemIndex]
                    : randomItemIndex
            );
        },

        _loadImage: function() {
            var promise = $.Deferred();
            var $img, timeout;

            if (!this._$nextGameWithDynamicImage || !this._$nextGameWithDynamicImage.length) {
                return promise.reject();
            }

            var nextImageUrl = this._getNextImageUrl();

            var onLoadComplete = function(action) {
                window.clearTimeout(timeout);
                $img.remove();

                if (action === 'reject') {
                    listOfUnloadedImages.push(nextImageUrl);
                }

                promise[action]();
            };

            timeout = window.setTimeout(onLoadComplete.bind(null, 'reject'), this._IMAGE_LOAD_TIMEOUT);

            if (listOfUnloadedImages.includes(nextImageUrl)) {
                window.clearTimeout(timeout);
                promise.reject();
            } else {
                $img = $('<img />')
                    .on('load', onLoadComplete.bind(null, 'resolve'))
                    .on('error', onLoadComplete.bind(null, 'reject'))
                    .attr('src', nextImageUrl);
            }

            return promise;
        },

        _setDynamicGameImage: function() {
            var $nextDynamicGameImage = this._getNextImageEl();
            this._currentGameStaticBackgroundImage = $nextDynamicGameImage.css('backgroundImage');
            $nextDynamicGameImage.css('backgroundImage', 'url(' + this._getNextImageUrl() + ')');
            this._$currentGameWithDynamicImage = this._$nextGameWithDynamicImage;
        },

        _restoreStaticGameImage: function() {
            if (this._$currentGameWithDynamicImage) {
                this._getCurrentImageEl().css('backgroundImage', this._currentGameStaticBackgroundImage);
                this._$currentGameWithDynamicImage = null;
                this._currentGameStaticBackgroundImage = null;
            }
        },

        _startTimer: function() {
            var promise = $.Deferred();

            window.setTimeout(function() {
                promise.resolve();
            }, this._gamesInfoView.model.get('animatedGifDuration') * 1000);

            return promise;
        },

        //endregion

        //region Utility methods

        _getCurrentImageEl: function() {
            return this._$currentGameWithDynamicImage.find('.fn-game-image');
        },

        _getNextImageEl: function() {
            return this._$nextGameWithDynamicImage.find('.fn-game-image');
        },

        _getNextImageUrl: function() {
            var TILE_CLS_PREFIX = 'layout_tile_';
            var tileCls = _.find(this._$nextGameWithDynamicImage[0].classList, function(cls) {
                return cls.startsWith(TILE_CLS_PREFIX);
            });
            var tileSize = tileCls ? tileCls.replace(TILE_CLS_PREFIX, '') : 'c1x1';

            return this._gamesInfoView.model.games.get(
                this._getGameCode(this._$nextGameWithDynamicImage)
            ).get('animatedImageURLs')[tileSize];
        },

        _getVisibleGames: function() {
            return $(this._$currentPageGames.filter(function(currentPageGame) {
                return $(currentPageGame).isInViewportByPercentage(0.5);
            }));
        },

        _getGameCode: function(el) {
            return $(el).data('gameCode')
                ? $(el).data('gameCode')
                : $(el).find('[data-game-code]').data('gameCode');
        }

        //endregion

    });
});
